import { Input } from "@/src/components/universalInput";
import { FieldsSection } from "@/src/data/allTypes";
import { useState } from "react";
import {
  ConditionGroupPickerButton,
  parseConditionGroup,
  stringifyConditionGroup,
} from "../../documents/documentConditions";
import { MySelect } from "@/src/components/mySelect";
import { closeDrawer, openDrawer } from "@/src/components/dialogs";
import apiFetch from "@/src/utils/apiFetch";
import { getUserId } from "@/src/utils/utils";
import { Button } from "@/src/components/buttons";
import { openAiFieldSectionForm } from "./aiFieldSectionForm";

export default function FieldsSectionForm({
  allSections,
  current,
  onChange,
  onGenerate,
}: {
  allSections: (FieldsSection | null | undefined)[];
  current?: FieldsSection;
  onChange: (newValue: FieldsSection) => void;
  onGenerate: (newValue: FieldsSection) => void;
}) {
  let [fieldsSection, setData] = useState(current || ({} as FieldsSection));
  function setNewValue(newValue: FieldsSection) {
    setData(newValue);
    onChange(newValue);
  }

  console.log("fieldsSection", fieldsSection);
  return (
    <div className="grid gap10 c1">
      <Input
        name={"Nom"}
        shouldFocus={true}
        type={"text"}
        value={fieldsSection.name}
        onChange={(newValue) => {
          setNewValue({ ...fieldsSection, name: newValue });
        }}
      />

      <Input
        name={"Type"}
        type={"chips"}
        value={fieldsSection.type}
        options={[
          { value: "simple", label: "Simple" },
          { value: "table", label: "Tableau" },
        ]}
        onChange={(newValue) => {
          setNewValue({ ...fieldsSection, type: newValue });
        }}
      />

      <Input
        name={"Accordéon"}
        type={"chips"}
        value={fieldsSection.isExpandable == true ? "true" : "false"}
        options={[
          { value: "true", label: "Oui" },
          { value: "false", label: "Non" },
        ]}
        onChange={(newValue) => {
          setNewValue({ ...fieldsSection, isExpandable: newValue == "true" });
        }}
      />
      <Input
        name={"Afficher automatiquement pour les sous-concepts"}
        type={"chips"}
        value={
          fieldsSection.isCommonWithSnomedChildren == true ? "true" : "false"
        }
        options={[
          { value: "true", label: "Oui" },
          { value: "false", label: "Non" },
        ]}
        onChange={(newValue) => {
          setNewValue({
            ...fieldsSection,
            isCommonWithSnomedChildren: newValue == "true",
          });
        }}
      />

      {fieldsSection.type == "table" && (
        <Input
          name={"Colonnes"}
          type={"select-multiple"}
          isCreatable={true}
          value={fieldsSection.tableColumns}
          placeholder="Colonnes de la table"
          options={[]}
          onChange={(newValue) => {
            console.log("newValue", newValue);
            setNewValue({
              ...fieldsSection,
              tableColumns: newValue,
            });
          }}
        />
      )}
      {fieldsSection.type == "table" && (
        <Input
          name={"Lignes"}
          type={"select-multiple"}
          isCreatable={true}
          value={fieldsSection.tableRows}
          placeholder="Lignes de la table"
          options={[]}
          onChange={(newValue) => {
            console.log("newValue", newValue);
            setNewValue({
              ...fieldsSection,
              tableRows: newValue,
            });
          }}
        />
      )}

      <ConditionGroupPickerButton
        current={parseConditionGroup(fieldsSection.conditionGroupStr)}
        onChange={(newValue) => {
          setNewValue({
            ...fieldsSection,
            conditionGroupStr: stringifyConditionGroup(newValue),
          });
        }}
        sections={allSections}
      ></ConditionGroupPickerButton>

      <Button
        onClick={async () => {
          await openAiFieldSectionForm({
            current: fieldsSection,
            currentPrompt: "",

            onSave: (newValue) => {
              setNewValue(newValue);
              onGenerate(newValue);
            },
          });
        }}
      >
        Générer par IA
      </Button>
    </div>
  );
}

export async function openFieldsSectionsForm({
  current,
  allSections,
  onSave,
}: {
  current?: FieldsSection | null;
  allSections: (FieldsSection | null | undefined)[];
  onSave: (newValue: FieldsSection) => void;
}) {
  current ||= {
    name: `Section ${allSections.length + 1}`,
    type: "simple",
    fields: [],
    isExpandable: false,
    conditionGroupStr: null,

    creator: getUserId(),
  };

  await openDrawer({
    id: "fieldsSectionForm",
    title: "Section",
    content: (
      <FieldsSectionForm
        allSections={allSections}
        current={current}
        onGenerate={(newValue) => {
          onSave(newValue);
          closeDrawer("fieldsSectionForm");
        }}
        onChange={(newValue) => {
          current = newValue;
        }}
      />
    ),
    onConfirm: async () => {
      if (!current) throw new Error("current is null");
      current = await apiFetch("fieldsSections", "addOne", {
        fieldsSection: current,
      });
      onSave(current);
    },
  });
}
